import Component from "../../../../js/assets/component.js"

class TourDetailConfirmApplication extends Component{
  static get travelConditionCheckError() { return '「取消料及び条件書を確認しました」にチェックを入れてください。' }
  constructor(selector) {
    // set root element
    super(selector)
  }

  data(){
    return {
      "isSubmit": false,
      "requestURL": null
    }
  }

  changed(){
    return {
      "isSubmit": (val)=>{
        //２重送信防止
        if(val === true){
          this.submitButton.attr({
            "disabled" : "disabled"
          })
        }
      },
      "requestURL": (val)=>{
        this.form.attr('action', val)
      }
    }
  }

  isCashPayment() {
    const cashPaymentId = 3
    return Number(this.$el.data('saleType')) === cashPaymentId
  }

  cashUrl() {
    return this.$el.data('shoppingCheckoutCashUrl')
  }

  zeusUrl() {
    return this.$el.data('shoppingCheckoutZeusUrl')
  }

  checkTravelConditions(){
    let isChecked = this.$el.find("#travelConditions_checkInput").prop('checked')
    return isChecked
  }

  alertMessages(messages) {
    if (Array.isArray(messages)) {
      this.$el.find('.outOfStockAlert_content').first().html(messages.join("<br>"))
    } else {
      this.$el.find('.outOfStockAlert_content').first().text(messages)
    }

    this.$el.find('#outOfStockAlert').fadeIn()
  }

  mounted() {
    this.form = this.$el.find('#shopping-form')
    this.form.on("submit", ()=>{
      // console.log(this.$data.requestURL)
      //送信済みフラグセット
      this.$data.isSubmit = true
    })

    this.submitButton = this.$el.find('#confirm-submit-button')
    this.submitButton.click((e) => {
      //デフォルトのsubmit抑制
      e.preventDefault()
      //取消料及び条件書を確認しましたをチェック
      if(!this.checkTravelConditions()){
        this.alertMessages(this.constructor.travelConditionCheckError)
        return false
      }
      //リクエストURLをセット
      const url = this.isCashPayment() ? this.cashUrl() : this.zeusUrl()
      this.$data.requestURL = url
      //送信
      this.form.submit()
    })
  }
}

// export as singleton
let instance = new TourDetailConfirmApplication("#tourDetailConfirmApplication")

// Object.seal(instance)
export default instance
